import { useEffect, useState } from 'react'

function useMessages() {

  const [messages, setMessages] = useState([]);

  // When messages changes, store into storage
  useEffect(() => {
    localStorage.setItem('messages', JSON.stringify(messages));
  }, [messages]);

  // Get all messages from the store
  function getMessagesFromStorage() {
    const messages = localStorage.getItem('messages');
    const parsed = JSON.parse(messages);
    return parsed;
  }

  /**
   * Add a new message
   */
  function add(message) {
    let messages = [...getMessagesFromStorage()];
    setMessages([message, ...messages.slice(0,2)]);
  }

  /**
   * Get all the (current) messages
   */
  function get() {
    return [...getMessagesFromStorage()];
  }

  /**
   * Clear all messages
   */
  function clear() {
    setMessages([]);
  }

  return {
    messages,
    add,
    clear,
    get,
  };
};

export default useMessages;
